import React from "react";
import "./footer.css";

import { BsFacebook } from "react-icons/bs";
import { BsInstagram } from "react-icons/bs";
import { BsTelegram } from "react-icons/bs";

const footer = () => {
  return (
    <footer>
      <a href="/" className="footer_logo">
        TAUREUS
      </a>
      <ul className="premalink">
        <li>
          <a href="/">Home</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#experience">Experiences</a>
        </li>
        <li>
          <a href="#service">Services</a>
        </li>
        <li>
          <a href="#portfolio">Portfolio</a>
        </li>

        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>
      <div className="footer_social">
        <a
          href="https://www.facebook.com/rahul.batham.3726613"
          target="_blank"
          rel="noreferrer"
        >
          <BsFacebook />
        </a>
        <a
          href="https://www.facebook.com/rahul.batham.3726613"
          target="_blank"
          rel="noreferrer"
        >
          <BsInstagram />
        </a>
        <a
          href="https://telegram.me/What_to_right"
          target="_blank"
          rel="noreferrer"
        >
          <BsTelegram />
        </a>
      </div>
      <div className="footer_copyright">
        <small>&copy;Taureus.All right reserved</small>
      </div>
    </footer>
  );
};

export default footer;
